<script setup lang="ts">
  import { BackButton } from '@/shared/ui/components'

  import CreateEmployee from '@/views/admin/employee/Create.vue'

  const route = useRoute('/admin/employees/new')
  const departmentId = route.query.departmentId as string
  definePage({
    meta: {
      layout: 'admin',
    },
  })
</script>

<template>
  <div class="head">
    <div class="flex items-center gap-4">
      <BackButton
        :route="{
          name: '/admin/employees',
        }"
        type="rounded"
      />
      <h2 class="text-2xl font-bold">{{ $t('admin_employee_new_employee') }}</h2>
    </div>
  </div>
  <div class="content mt-4">
    <CreateEmployee :department-id="departmentId" />
  </div>
</template>

<style scoped lang="scss"></style>
